// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__oxygy","headingText":"Heading_headingText__Z424f","headingAccessories":"Heading_headingAccessories__yOKgR"};